export default __webpack_public_path__ + "b4ad1217096b1d27077abb93d6c8ca0e.png";